import { render } from "./ExchangeCode.vue?vue&type=template&id=764b39fc&scoped=true"
import script from "./ExchangeCode.vue?vue&type=script&lang=js"
export * from "./ExchangeCode.vue?vue&type=script&lang=js"

import "./ExchangeCode.vue?vue&type=style&index=0&id=764b39fc&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-764b39fc"]])

export default __exports__